import {
	buildTemplatePayload,
	BuildTemplatePayloadInput,
	BuildTemplatePayloadOutput,
	extractTeamStringCustomFields,
	ExtractTeamStringCustomFieldsInput,
} from './parityHarness';

export function buildTemplatePayloadAdapter (input: BuildTemplatePayloadInput): BuildTemplatePayloadOutput {
	return buildTemplatePayload(input);
}

export function extractCustomFieldsForOwnerSelection (input: ExtractTeamStringCustomFieldsInput): Record<string, string> {
	return extractTeamStringCustomFields(input);
}

export function buildCreatedRunnitStateSnapshot<T extends Record<string, any>> (
	templateData: T,
	templateId: string,
): Readonly<T & { id: string; avatar: null }> {
	return Object.freeze({
		...templateData,
		avatar: null,
		id: templateId,
	}) as Readonly<T & { id: string; avatar: null }>;
}
